document.querySelectorAll('.cart-drawer__section--subtotal')?.forEach(e => {
    e.style.width = "100%";
});

document.querySelectorAll('.is-size-variant').forEach( element =>{
        element.addEventListener('click', function(){
            var this_val = this.innerHTML;
            document.querySelector('.current-varient__sellected').innerHTML = this_val;
        })
    })
document.querySelectorAll('.is-size-variant')[0]?.click();

document.addEventListener("rebuy.ready", (event) => {
const widget = event.detail.widget;
document.querySelectorAll(`#rebuy-widget-${widget.id} .rebuy-product-block`).forEach((product, productIndex) => {
    let imageArr = []
    product.querySelectorAll('.variant-option img').forEach((image, imageIndex) => {
    if (imageArr.includes(image.getAttribute("alt"))) {
        image.style.display = "none"
    } else {
        imageArr.push(image.getAttribute("alt"))
    }
    })
})
})

$('.static-colors').each(function () {
    var swatch_section = $(this);
    var swatch_elements = swatch_section.find('.metafiles-wrapper .swatch-element');

    swatch_elements.each(function () {
        var label = $(this).find('label');
        var bg = label.css('background-image');
        var bga = bg.replace('url(','').replace(')','').replace(/\"/gi, "");

        var image = `<img class="ls-is-cached lazyload" data-src="${bga}" src="${bga}"><span>${$(this).find('.tooltip').text()}</span>`;
        $(this).find('.tooltip').html(image); 
    });
});

document.querySelectorAll('.swatch-element.color.available').forEach(element => {
    element.addEventListener('click', function() {
        document.querySelectorAll('.swatch-element.color.available').forEach(el => el.classList.remove('active'));
        this.classList.add('active');
    });
});